var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-len */
import React from "react";
import id from "@irati/utils/id";
import BaseSvgIcon from "./Base";
var SummaryComments = function (props) {
    var titleId = id("title", props);
    var title = props.title, rest = __rest(props, ["title"]);
    return (React.createElement(BaseSvgIcon, __assign({}, rest, { "aria-labelledby": titleId }),
        React.createElement("path", { d: "m8.04545455 12.1623685c-2.57958956-.3543481-4.54545455-2.1167124-4.54545455-4.29873214 0-2.4588528 2.48780797-4.36363636 5.5-4.36363636 3.012192 0 5.5 1.90478356 5.5 4.36363636 0 .88681922-.330241 1.7365787-.8969374 2.39257064-.0393547.063382-.0863101.1224262-.1402809.176397l-.1134428.1133815c-.0216611.0219926-.0216611.0219926-.036541.0369415-.0002202.0002201-.0002202.0002201-.0004404.00044-.0133225.0132408-.0133225.0132408-.0285772.0282384l-3.60881474 3.6088147c-.60133009.6013301-1.62951101.1754436-1.62951101-.6749656z", fill: "#00adee", stroke: "#3d3d36" })));
};
SummaryComments.defaultProps = {
    id: "summary-comments-icon",
    title: "Comments"
};
export default SummaryComments;
